module.exports = __webpack_public_path__ + "img/WF.0b339404.svg";